import { useState } from "react";
import { Text } from "@/components/ui/text";
import CloseIcon from "@/components/ui/icons/CloseIcon";
import ChatMemoItem from "./chat-memo-item";
import type { ChatMemo } from "./types";
import { PlusIcon } from "lucide-react";
import ChatMemoSearchBar from "./chat-memo-search-bar";
import SearchIcon from "../ui/icons/SearchIcon";

interface ChatMemoListProps {
  chatTitle: string;
  memos: ChatMemo[];
  onMemoClick: (memo: ChatMemo) => void;
  onNewMemo: () => void;
  onClose: () => void;
  onDeleteMemo: (id: string) => void;
}

const ChatMemoList = ({
  chatTitle,
  memos,
  onMemoClick,
  onNewMemo,
  onClose,
  onDeleteMemo,
}: ChatMemoListProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  console.log("memos", memos);

  const filteredMemos = searchQuery
    ? memos?.filter(
        (memo) =>
          memo.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
          memo.content.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : memos || [];

  // 검색 시에는 그룹화하지 않고 전체 표시
  const displayMemos = searchQuery ? filteredMemos : memos || [];

  return (
    <div className="flex h-full flex-col ">
      {/* Header */}
      <div className="flex items-center justify-between bg-white px-6">
        <Text variant="title-lg" className="font-bold">
          Chat Memo
        </Text>
        <button
          onClick={onClose}
          className="flex h-10 w-10 items-center justify-center"
        >
          <CloseIcon color="#333333" />
        </button>
      </div>

      {/* Category Title */}
      <div className="bg-white py-6 text-center px-6">
        <Text variant="title-md" className="font-bold">
          {chatTitle}
        </Text>
      </div>

      {/* Memo List */}
      <div className="flex-1 overflow-y-auto px-6">
        {displayMemos.length === 0 ? (
          <div className="flex h-full items-center justify-center">
            <Text variant="body-md" className="text-gray-400">
              메모가 없습니다
            </Text>
          </div>
        ) : (
          <div className="flex flex-col gap-6">
            {displayMemos.map((memo) => (
              <ChatMemoItem
                key={memo.id}
                memo={memo}
                onClick={() => onMemoClick(memo)}
                onDelete={() => onDeleteMemo(memo.id)}
              />
            ))}
          </div>
        )}
      </div>

      {/* Footer */}
      {isSearchOpen ? (
        <ChatMemoSearchBar
          setIsSearchOpen={setIsSearchOpen}
          onSearch={setSearchQuery}
        />
      ) : (
        <div className="flex items-center justify-between border-t border-gray-200 bg-white px-6 py-4">
          <button
            onClick={onNewMemo}
            className="flex items-center gap-2 rounded-lg bg-grey-95 px-4 py-2 text-black transition-colors "
          >
            <PlusIcon className="w-4 h-4" />
            <Text variant="label-lg" className="text-black">
              New Memo
            </Text>
          </button>
          <button
            onClick={() => {
              setIsSearchOpen(true);
            }}
            className="flex h-10 w-10 items-center justify-center"
          >
            <SearchIcon color="#333333" />
          </button>
        </div>
      )}
    </div>
  );
};

export default ChatMemoList;
